import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateAccountFormComponent } from './components';
import { KeycloakAuthGuardService } from './services/KeycloakAuthGuardService';
import { ProfileComponent } from './pages/profile/profile.component';
import { TasksComponent } from './pages/tasks/tasks.component';
import { DxButtonGroupModule, DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxDateBoxModule, DxFormModule, DxListModule, DxLoadPanelModule, DxLookupModule, DxNumberBoxModule, DxPopupModule, DxProgressBarModule, DxScrollViewModule, DxSelectBoxModule, DxTextAreaModule, DxTextBoxModule, DxToolbarModule, DxValidatorModule, DxTabsModule, DxTagBoxModule, DxResponsiveBoxModule } from 'devextreme-angular';
import { RegisterMerchantComponent } from './pages/register-merchant/register-merchant.component';
import { TransactionsComponent } from './pages/transactions/transactions.component';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { BatchComponent } from './pages/batch/batch.component';
import { CardDisbursementComponent } from './pages/card-disbursement/card-disbursement.component';
import { BatchTransactionComponent } from './pages/batch-transaction/batch-transaction.component';
import { AccountTopUpComponent } from './pages/account-top-up/account-top-up.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatStepperModule } from '@angular/material/stepper';
import { TextFieldModule } from '@angular/cdk/text-field';
import { RegisterMerchantFormContainerComponent } from './pages/register-merchant/register-merchant-form-container/register-merchant-form-container.component';
import { CompanyDetailsComponent } from './pages/register-merchant/company-details/company-details.component';
import { ContactDetailsComponent } from './pages/register-merchant/contact-details/contact-details.component';
import { AddressComponent } from './pages/register-merchant/address/address.component';
import { DocumentsComponent } from './pages/register-merchant/documents/documents.component';
import { DirectDebitInstructionsComponent } from './pages/register-merchant/direct-debit-instructions/direct-debit-instructions.component';
import { LedgerTransactionComponent } from './pages/ledger-transaction/ledger-transaction.component';
import { CardBalanceTransactionComponent } from './pages/card-balance-transaction/card-balance-transaction.component';
import { MerchantComponent } from './pages/merchant/merchant.component';
import { DxFileUploaderModule } from "devextreme-angular";
import { DxBoxModule } from 'devextreme-angular';
import { AddMoneyComponent } from './pages/add-money/add-money.component';
import { WalletComponent } from './pages/wallet/wallet.component';
import { PopupSignalService } from './services/popup-signal.service';
import { RegisterMerchantServicesComponent } from './pages/register-merchant/register-merchant-services/register-merchant-services.component';
import { HomeComponent } from './pages/home/home.component';
import { RichFormModule } from './components/library/rich-form/rich-form.component';
import { PicturedCountrySelectBoxComponent } from './components/library/pictured-country-select-box/pictured-country-select-box.component';
import { PricelistComponent } from './pages/pricelist/pricelist.component';
import { ServiceComponent } from './pages/service/service.component';
import { CountryComponent } from './pages/country/country.component';
import { DashboardComplianceComponent } from './pages/dashboard-compliance/dashboard-compliance.component';
import { BankComponent } from './pages/bank/bank.component';
import { MerchantComplianceComponent } from "./pages/compliance/merchant-compliance/merchant-compliance.component";
import { CountryGridComponent } from './pages/country-grid/country-grid.component';
import { MerchantValidationComponent } from './pages/compliance/merchant-validation/merchant-validation.component';
import { FormPopupModule } from './components/library/form-popup/form-popup.component';
import { RequestAdditionalInfoComponent } from "./pages/compliance/request-additional-info/request-additional-info.component";
import { DeclineComponent } from "./pages/compliance/decline/decline.component";
import { ApproveComponent } from "./pages/compliance/approve/approve.component";
import { QuickActionsComponent } from './pages/finance/quick-actions/quick-actions.component';
import { LedgerTransactionCardsSummaryPipe } from './pipes/LedgerTransactionCardsSummaryPipe';
import { DataInformationCardModule } from "./components/library/data-information-card/data-information-card.component";
import { MerchantCardsOverviewPipe } from './pipes/MerchantCardsOverviewPipe';
import { DxHttpModule } from 'devextreme-angular/http';

const routes: Routes = [
  {
    path: 'register-merchant',
    data: { url: 'register-merchant' },
    component: RegisterMerchantComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'pricelist',
    data: { url: 'pricelist' },
    component: PricelistComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'home',
    data: { url: 'home' },
    component: HomeComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'profile',
    data: { url: 'profile' },
    component: ProfileComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'tasks',
    data: { url: 'tasks' },
    component: TasksComponent,
    canActivate: [KeycloakAuthGuardService]

  },
  {
    path: 'company-info',
    data: { url: 'company-info' },
    component: CompanyDetailsComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'transactions',
    data: { url: 'transactions' },
    component: TransactionsComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'ledger',
    data: { url: 'ledger' },
    component: LedgerTransactionComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'batches',
    data: { url: 'batches' },
    component: BatchComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'batch-transactions',
    data: { url: 'batch-transactions' },
    component: BatchTransactionComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'account-top-ups',
    data: { url: 'account-top-ups' },
    component: AccountTopUpComponent,
    canActivate: [KeycloakAuthGuardService]
  }
  ,
  {
    path: 'card-balance-transactions',
    data: { url: 'card-balance-transactions' },
    component: CardBalanceTransactionComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'merchants',
    data: { url: 'merchants' },
    component: MerchantComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'cards',
    data: { url: 'cards' },
    loadComponent: () => import('./pages/cards/card.component').then(c => c.CardComponent),
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'wallets',
    component: WalletComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'create-account',
    data: { url: 'create-account' },
    component: CreateAccountFormComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'service',
    data: { url: 'service' },
    component: ServiceComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'country',
    data: { url: 'country' },
    component: CountryComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'bank',
    data: { url: 'bank' },
    component: BankComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'dashboard-compliance',
    data: { url: 'dashboard-compliance' },
    component: DashboardComplianceComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'merchant-validation',
    data: { url: 'merchant-validation' },
    component: MerchantValidationComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: 'quick-actions',
    data: { url: 'quick-actions' },
    component: QuickActionsComponent,
    canActivate: [KeycloakAuthGuardService]
  },
  {
    path: '**',
    redirectTo: 'register-merchant'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true }),
    DxDataGridModule,
    DxFormModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    DxFileUploaderModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatStepperModule,
    TextFieldModule,
    DxPopupModule,
    DxButtonModule,
    DxTextBoxModule,
    DxTextAreaModule,
    DxNumberBoxModule,
    DxValidatorModule,
    DxProgressBarModule,
    DxButtonGroupModule,
    DxCheckBoxModule,
    DxBoxModule,
    DxSelectBoxModule,
    DxDateBoxModule,
    DxToolbarModule,
    DxLoadPanelModule,
    DxScrollViewModule,
    RichFormModule,
    DxLookupModule,
    DxListModule,
    DxTabsModule,
    MerchantComplianceComponent,
    CountryGridComponent,
    DxTagBoxModule,
    DxResponsiveBoxModule,
    FormPopupModule,
    RequestAdditionalInfoComponent,
    DeclineComponent,
    ApproveComponent,
    DataInformationCardModule,
    DxHttpModule
],
  providers: [KeycloakAuthGuardService, PopupSignalService],
  exports: [RouterModule, LedgerTransactionCardsSummaryPipe],
  declarations: [
    HomeComponent,
    ProfileComponent,
    TasksComponent,
    RegisterMerchantComponent,
    BatchComponent,
    CardDisbursementComponent,
    BatchTransactionComponent,
    AccountTopUpComponent,
    TransactionsComponent,
    RegisterMerchantFormContainerComponent,
    CompanyDetailsComponent,
    ContactDetailsComponent,
    AddressComponent,
    DocumentsComponent,
    DirectDebitInstructionsComponent,
    // HealthCheckComponent,
    LedgerTransactionComponent,
    CardBalanceTransactionComponent,
    MerchantComponent,
    AddMoneyComponent,
    WalletComponent,
    RegisterMerchantServicesComponent,
    PricelistComponent,
    ServiceComponent,
    CountryComponent,
    DashboardComplianceComponent,
    BankComponent,
    LedgerTransactionCardsSummaryPipe,
    MerchantCardsOverviewPipe
  ]
})
export class AppRoutingModule { }